/**
 * Filter DevTools console with: API-TRACE
 * Counts every ItemDetails / Recommendations / AvailableStock call.
 */

export const API_TRACE_TAG = '[API-TRACE]';

let seq = 0;

export type ApiTraceKind = 'ItemDetails' | 'Recommendations' | 'AvailableStock';

export function apiTrace(
    kind: ApiTraceKind,
    reason: string,
    fields: Record<string, string | number | boolean | null | undefined> = {}
): number {
    const n = ++seq;
    const parts = Object.entries(fields)
        .filter(([, v]) => v !== undefined && v !== null && `${v}` !== '')
        .map(([k, v]) => `${k}=${v}`)
        .join(' | ');
    // eslint-disable-next-line no-console
    console.log(
        `${API_TRACE_TAG} #${n} | ${kind} | reason=${reason || 'UNKNOWN'}${parts ? ' | ' + parts : ''}`
    );
    return n;
}

/** Mark a user action boundary in the console (clear before each test flow). */
export function apiTraceFlow(label: string, fields: Record<string, string | number | undefined> = {}): void {
    const parts = Object.entries(fields)
        .filter(([, v]) => v !== undefined && v !== null && `${v}` !== '')
        .map(([k, v]) => `${k}=${v}`)
        .join(' | ');
    // eslint-disable-next-line no-console
    console.log(
        `${API_TRACE_TAG} ===== FLOW: ${label}${parts ? ' | ' + parts : ''} =====`
    );
}

export function apiTraceResetCounter(): void {
    seq = 0;
    // eslint-disable-next-line no-console
    console.log(`${API_TRACE_TAG} ===== COUNTER RESET =====`);
}
